module.exports = __webpack_public_path__ + "img/help-ct7.0ee93892.png";